import { NgModule } from '@angular/core';

import { SwiperModule } from 'swiper/angular';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { SharedModule } from 'src/app/shared.module';
import { PostsComponent } from './posts.component';
import { NewVisitComponent } from './new-visit/new-visit.component';
import { RouterModule } from '@angular/router';
import { ShellModule } from '../shell/shell.module';
import { ModalPictureModule } from '../modal-picture/modal-viewer-activity.module';
import { NewMiradorComponent } from './new-mirador/new-mirador.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TopViewpointsMonthlyComponent } from './top-viewpoints-monthly/top-viewpoints-monthly.component';
import { CurrentMonthTopViewpointsComponent } from './current-month-top-viewpoints/current-month-top-viewpoints.component';
import { RankingAdventurersComponent } from './ranking-adventurers/ranking-adventurers.component';
import { NewVisitExperienceComponent } from './new-visit-experience/new-visit-experience.component';

@NgModule({
  imports: [ SharedModule, SwiperModule, PipesModule, RouterModule, ShellModule, ModalPictureModule,ScrollingModule],
  declarations: [PostsComponent, NewVisitComponent, NewMiradorComponent, RankingAdventurersComponent, TopViewpointsMonthlyComponent, CurrentMonthTopViewpointsComponent, NewVisitExperienceComponent ],
  exports: [PostsComponent]
})
export class PostCardModule {}
